<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-row align="center">
      <v-col cols="12" sm="4">
        <v-text-field
          label="CEP *"
          v-model="cep"
          v-mask="['#####-###']"
          :loading="buscaCep"
          :disabled="buscaCep"
          loading-text="Buscando cep..."
          :counter="9"
          @change="buscarCep"
          :readonly="isAllowed"
          :rules="[
            (v) => !!v || 'O Cep é obrigatório',
            (v) => (v && v.length == 9) || 'O Cep deve ter 9 caracteres',
          ]"
          required
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="8">
        <v-text-field
          label="Endereço *"
          v-model="logradouro"
          v-uppercase="uppercase"
          :counter="200"
          :readonly="isAllowed"
          :rules="[(v) => !!v || 'O Endereço é obrigatório']"
          required
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row align="center">
      <v-col cols="12" sm="3">
        <v-text-field
          label="Número *"
          v-model="numero"
          :counter="50"
          :readonly="isAllowed"
          :rules="[(v) => !!v || 'O Número é obrigatório']"
          required
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="3">
        <v-text-field
          label="Complemento"
          v-model="complemento"
          v-uppercase="uppercase"
          :counter="50"
          :readonly="isAllowed"
        ></v-text-field> </v-col
      ><v-col cols="12" sm="6">
        <v-text-field
          label="Bairro *"
          v-model="bairro"
          v-uppercase="uppercase"
          :counter="200"
          :readonly="isAllowed"
          :rules="[(v) => !!v || 'O Bairro é obrigatório']"
          required
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row align="center">
      <v-col cols="12" sm="10">
        <v-text-field
          label="Cidade *"
          v-model="cidade"
          v-uppercase="uppercase"
          :counter="200"
          :readonly="isAllowed"
          :rules="[(v) => !!v || 'A Cidade é obrigatória']"
          required
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="2">
        <v-text-field
          label="UF *"
          v-model="uf"
          v-uppercase="uppercase"
          :counter="2"
          :readonly="isAllowed"
          :rules="[
            (v) => !!v || 'A UF é obrigatória',
            (v) => (v && v.length == 2) || 'A UF deve ter 2 caracteres',
          ]"
          required
        ></v-text-field>
      </v-col>
    </v-row>
    <v-snackbar v-model="errorMessage" color="error" timeout="3000"
      >Cep não encontrado!
    </v-snackbar>
  </v-form>
</template>

<script>
import { buscarCepAsync } from "../../services/empresaService";
import { normalizeTextUppercase } from "../../utils";

export default {
  name: "endereco",
  data: () => ({
    valid: true,
    cep: null,
    logradouro: null,
    numero: null,
    complemento: null,
    bairro: null,
    cidade: null,
    uf: null,
    buscaCep: false,
    errorMessage: false,
  }),
  props: {
    isAllowed: Boolean,
    uppercase: Boolean,
  },
  methods: {
    normalizarMaiusculo(valor) {
      return this.uppercase ? normalizeTextUppercase(valor) : valor;
    },
    async buscarCep() {
      if (this.cep.length == 9) {
        this.buscaCep = true;
        const dados = await buscarCepAsync(this.cep);
        if (dados != null) {
          this.logradouro = this.normalizarMaiusculo(dados.street);
          this.bairro = this.normalizarMaiusculo(dados.district);
          this.cidade = this.normalizarMaiusculo(dados.city);
          this.uf = this.normalizarMaiusculo(dados.state);
          this.ativo = true;
        } else {
          this.errorMessage = true;
        }
        this.buscaCep = false;
      }
    },
    updateObjectEstate() {
      return this.$refs.form.validate();
      /*if (
        !this.cep ||
        !this.logradouro ||
        !this.numero ||
        !this.bairro ||
        !this.cidade ||
        !this.uf
      ) {
        if (!this.cep) this.errors.push("cep");
        if (!this.logradouro) this.errors.push("logradouro");
        if (!this.bairro) this.errors.push("bairro");
        if (!this.cidade) this.errors.push("cidade");
        if (!this.uf) this.errors.push("uf");
        if (!this.numero) this.errors.push("numero");
        return false;
      } else {
        return true;
      }*/
    },
    updateObject2(endereco) {
      this.cep = endereco.cep;
      this.logradouro = endereco.logradouro;
      this.numero = endereco.numero;
      this.complemento = endereco.complemento;
      this.bairro = endereco.bairro;
      this.cidade = endereco.cidade;
      this.uf = endereco.uf;
    },

    clear() {
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
      /*
      this.cep = null;
      this.logradouro = null;
      this.numero = null;
      this.complemento = null;
      this.bairro = null;
      this.cidade = null;
      this.uf = null;
      */
    },
  },
};
</script>